import React from "react";
import { Link, NavLink } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { sidebarmenu } from "../data/staticdata";
//* Warm "dt" brand monogram — matches the marketing site + app icons.
import brandMark from "../data/logo-icon-light.png";
import { useStateContext } from "../contexts/ContextProvider";
import { useAuth } from "../contexts/AuthContext";
import { filterAdminOnly } from "./shell/adminOnly";

const Sidebar = () => {
  const { user } = useAuth();
  const { currentColor, activeMenu, setActiveMenu, screenSize } =
    useStateContext();
  const { setPageCat, setPageName } = useStateContext();

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const handleSideBarClick = (item, LinkName) => {
    console.log("Navigating to page:", LinkName);
    setPageCat(item.title);
    setPageName(LinkName);
  };

  // Enhanced link styles with modern transitions
  //--> DS motion: hover/selected state = background+color only, --dur-instant
  //    (80ms) + --ease-standard — matches menu items / segmented / table rows.
  //    No scale transform (the DS signals state with color, not size).
  const linkBase =
    "flex items-center gap-3 px-1.5 py-1.5 rounded-sm text-sm mx-1.5 truncate transition-colors duration-[var(--dur-instant)] ease-[var(--ease-standard)]";
  const activeLink = `${linkBase} text-white`;
  const normalLink = `${linkBase} text-fg-2 hover:bg-bg-3 dark:hover:bg-bg-3/50`;

  return (
    <div className="h-screen overflow-y-auto no-scrollbar pb-10 transition-all duration-300">
      <div className="flex justify-between items-center px-3">
        <Link
          to="/"
          onClick={handleCloseSideBar}
          className="items-center gap-2 mt-4 flex text-xl font-extrabold tracking-tight text-fg-1"
        >
          <div className="transform transition hover:scale-105 duration-200">
            <img
              className="self-center h-8 w-8 block"
              src={brandMark}
              alt=""
              aria-hidden="true"
            />
          </div>
          <span>DeeTrade</span>
        </Link>
        <button
          type="button"
          onClick={() => setActiveMenu(!activeMenu)}
          style={{ color: currentColor }}
          className="text-xl rounded-full p-3 hover:bg-bg-3 mt-4 block md:hidden hover:shadow-lg transform hover:scale-105 transition-all duration-200"
        >
          <MdOutlineCancel />
        </button>
      </div>
      <div className="mt-5">
        {sidebarmenu.map((item) => (
          <div key={item.title} className="mb-5">
            <p className="text-fg-3 mx-2 mb-2 uppercase text-[11px] font-medium tracking-wider">
              {item.title}
            </p>
            <div className="space-y-0.5">
              {filterAdminOnly(item.links, user)
                .map((link) => (
                <NavLink
                  to={`/${link.name}`}
                  key={link.name}
                  end={link.end}
                  onClick={() => {
                    handleCloseSideBar();
                    handleSideBarClick(item, link.name);
                  }}
                  style={({ isActive }) => ({
                    backgroundColor: isActive ? currentColor : "",
                  })}
                  className={({ isActive }) =>
                    isActive ? activeLink : normalLink
                  }
                >
                  <div className="text-lg opacity-80">{link.icon}</div>
                  <span className="capitalize text-sm">
                    {link.displayName || link.name}
                  </span>
                </NavLink>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
